import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import { AdvtService } from "../../../_services/advt.service";
import { AlertService } from "../../../_services/alert.service";
import { Router, ActivatedRoute } from "@angular/router";
import { Http, ResponseContentType } from "@angular/http";
import { Subscription } from "rxjs/Subscription";
import {
  NgxGalleryOptions,
  NgxGalleryImage,
  NgxGalleryAnimation,
} from "ngx-gallery";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { Location } from "@angular/common";
import * as FileSaver from "file-saver";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import "rxjs/add/operator/toPromise";
import { RatingDialogComponent } from "../../../rating-dialog/rating-dialog.component";
import { NotificationsService } from "angular2-notifications";
import { environment } from "../../../../environments/environment";

@Component({
  selector: "app-trade-detail",
  templateUrl: "./trade-detail.component.html",
  styleUrls: ["./trade-detail.component.css"],
})
export class TradeDetailComponent implements OnInit {
  @ViewChild("myVideo") public myVideo: any;
  @ViewChild("myAudio") public myAudio: any;
  @ViewChild("template") public template: TemplateRef<any>;
  @ViewChild("ratingtemplate") public ratingtemplate: TemplateRef<any>;
  @ViewChild("paymentModal") public paymentModal: TemplateRef<any>;
  @ViewChild("sellerModal") public sellerModal: TemplateRef<any>;
  @ViewChild("ratingdialog") public ratingdialog: TemplateRef<any>;

  modalRef: BsModalRef;
  private sub: Subscription;
  public _id;
  item_id;
  amount: any = "";
  buyer_id;
  seller_id;
  public listSingleItem;
  public itemVideoName;
  public itemAudioName;
  public itemImageName;
  public bidPost: Boolean = false;
  galleryOptions: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[];
  galleryImagesUser: NgxGalleryImage[];
  galleryMusic = [];
  placeholder: any;
  currentUser: any;
  showButton: Boolean = false;
  showdownloadbutton: Boolean = false;
  NAP;
  orderCaptureId: "";
  approveGetPaypalApi: "";
  myTracks: any[];
  allTracks: any[];
  selectedTrack;
  getPayoutApi: "";
  ItemData;
  bidButton: Boolean = false;
  bidAmount;
  timeset;
  duration;
  control;
  MaxAmount;
  maxAmt;
  bid_Amount;
  mainLoader;
  loading: Boolean = false;
  modalText: String = "";
  UsersRating: Array<any> = [];
  UserRatingCount;
  pageSize = 5;
  pageNo = 1;
  ItemAvailable;
  imageData: any;
  unique = "";
  senderBatchId: "";
  payPayOutValue: "";

  purchaseImage;
  checkoutImage;
  chatImage;
  model = 3.5;
  itemData;
  tax_amount;
  tax = "3 %";
  payable_amount;
  amountCent;
  public payment_token;
  rating: number = 5;
  comment;
  RateData;
  status: Boolean = false;
  Ratestatus: Boolean = false;
  amt;
  emojiIcon;
  exchange;
  noVideo;
  ItemID;
  payoutStatus;
  private returnPaypalCapture: Subscription;
  payerToken_id;
  paypalPayer_id;

  constructor(
    private advtService: AdvtService,
    private alertService: AlertService,
    private modalService: BsModalService,
    private route: ActivatedRoute,
    private _location: Location,
    private http: Http,
    private sanitizer: DomSanitizer,
    private router: Router,
    private _NotificationsService: NotificationsService
  ) {}

  ngOnInit() {
    window.scrollTo(0, 0);
    if (this.payoutStatus == 201) {
      this.getPaymentPayouts();
    }
    this.returnPaypalCapture = this.route.queryParams.subscribe((res) => {
      if (res.token != null && res.PayerID != null) {
        this.loading = true;
        setTimeout(() => {
          this.payerToken_id = res.token;
          this.paypalPayer_id = res.PayerID;
          this.loading = false;
          if (this.payerToken_id != null && this.paypalPayer_id != null) {
            this.captureOrder();
          }
        }, 1000);
      }
    });
    this.unique = this.uuidv4();
    this.NAP = "../../assets/images/nap.jpg";
    this.noVideo = "../../assets/images/noVideo.png";
    this.mainLoader = "../../assets/images/BigLoader.gif";
    this.exchange = "../../assets/images/exchangetrade.png";
    const userInfo = JSON.parse(localStorage.getItem("currentUser"));
    this.currentUser = userInfo ? userInfo.result : null;
    this.buyer_id = userInfo.result ? userInfo.result.id : null;

    this.sub = this.route.params.subscribe((params) => {
      this._id = params["id"];
    });
    this.placeholder = "../../assets/images/pdf.png";

    this.getItemDetail();

    this.galleryOptions = [
      {
        width: "100%",
        height: "200px",
        thumbnailsColumns: 4,
        imageAnimation: NgxGalleryAnimation.Slide,
      },
      // max-width 800
      {
        breakpoint: 800,
        width: "100%",
        height: "300px",
        imagePercent: 80,
        thumbnailsPercent: 20,
        thumbnailsMargin: 20,
        thumbnailMargin: 20,
      },
      // max-width 400
      {
        breakpoint: 400,
        preview: false,
      },
    ];
    if (
      (navigator.userAgent.indexOf("Opera") ||
        navigator.userAgent.indexOf("OPR")) != -1
    ) {
      alert("Opera");
    } else if (navigator.userAgent.indexOf("Chrome") != -1) {
      this.showdownloadbutton = false;
      //  alert('Chrome');
    } else if (navigator.userAgent.indexOf("Safari") != -1) {
      this.showdownloadbutton = true;
    } else if (navigator.userAgent.indexOf("Firefox") != -1) {
      this.showdownloadbutton = true;
      //alert('Firefox');
      //FileSaver.saveAs(audiourl, itemAudioName);
    } else {
      /*else if((navigator.userAgent.indexOf("MSIE") != -1 ) || (!!document.documentMode == true )) //IF IE > 10
      {
        alert('IE'); 
      } */
    }
  }

  uuidv4() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  calculateTax() {
    let tax = 3; //  three percent
    this.tax_amount = (parseFloat(this.amt) * tax) / 100;
    if (isNaN(this.tax_amount)) {
      this.tax_amount = 0;
    }
    this.payable_amount = this.amt - 0 + (parseFloat(this.tax_amount) - 0);
    this.amountCent = parseFloat(this.payable_amount);
    this.createSandBoxOrderHref();
    if (isNaN(this.amountCent)) {
      this.amountCent = 0;
    }
  }

  public openModal(template: TemplateRef<any>) {
    //debugger;
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: "gray modal-md" })
    );
    this.createSandBoxOrderHref();
    this.loading = false;
  }

  /**
   * Function to open modal
   * @param template
   */

  /**
   * function to Disbale Modal
   * @param event
   */
  _hidemodal(event: any) {
    this.modalRef.hide();
  }

  /*
   * PAYMENT method
   */
  openCheckout() {
    //debugger;
    this.loading = true;
    this.modalRef.hide();

    setTimeout(() => {
      // this.loading = false;
      window.location.href = this.approveGetPaypalApi;
    }, 1000);
    // this.modalRef.hide();
    // var handler = (<any>window).StripeCheckout.configure({
    //   key: "pk_test_8qFDtezJbEFFBjestSU6TaFO00HPPmu2Tx",
    //   locale: "auto",
    //   token: (token: any) => {
    //     this.createOrder(token.id);
    //   },
    // });
    // handler.open({
    //   name: "Bidjones",
    //   image: "../../assets/images/logo.png",
    //   // description: 'abc',
    //   // amount: this.amountCent
    // });
  }

  createSandBoxOrderHref = async () => {
    //debugger;
    const response2 = await fetch(
      `${environment.sandBoxUrll}v2/checkout/orders`,
      {
        method: "POST",
        headers: {
          Authorization:
            "Bearer " + localStorage.getItem("CreatePaypalTokenresp"),
          "Content-Type": "application/json",
          "PayPal-Request-Id": `${this.unique}`,
          // "PayPal-Request-Id": "7b92603e-77ed-4896-8e78-5dea2050476d",
        },
        body: `{"intent": "CAPTURE",
          
                "purchase_units": [
            {
              "amount": {
                "currency_code": "USD",
                "value": ${this.amountCent}
              }
            }
          ],
          "payment_source": {
            "paypal": {
              "experience_context": {
                "payment_method_preference": "IMMEDIATE_PAYMENT_REQUIRED",
                "payment_method_selected": "PAYPAL",
                "brand_name": "Bid Jones",
                "locale": "en-US",
                "landing_page": "LOGIN",
                "shipping_preference": "SET_PROVIDED_ADDRESS",
                "user_action": "PAY_NOW",
                "return_url": "${environment.bidjonesUrl}trade/detail/${this.item_id}",
                "cancel_url": "${environment.bidjonesUrl}trade/detail/${this.item_id}"
              }
            }
          }
        }`,
      }
    ).then(async (response) => {
      if (response.status == 200) {
        // this.loading = true;
        const responseData = await Promise.all([response.json()]);
        this.approveGetPaypalApi = responseData[0].links[1].href;
        return responseData;
      } else {
        this.loading = false;
      }
    });
  };

  captureOrder = async () => {
    const response2 = await fetch(
      `${environment.sandBoxUrll}v2/checkout/orders/${this.payerToken_id}/capture`,
      {
        method: "POST",
        headers: {
          Authorization:
            "Bearer " + localStorage.getItem("CreatePaypalTokenresp"),
          "Content-Type": "application/json",
        },
        body: ``,
      }
    ).then(async (response) => {
      if (response.status == 201) {
        if (this.payerToken_id != null || this.payerToken_id != undefined) {
          const responseData = await Promise.all([response.json()]);
          this.senderBatchId =
            responseData[0].purchase_units[0].payments.captures[0].id;

          this.payPayOutValue =
            responseData[0].purchase_units[0].payments.captures[0].amount.value;
          this.orderCaptureId = responseData[0].id;
          this.loading = true;
          this.payoutOrder();
          return responseData;
        }
      } else if (response.status === 422) {
        this.alertService.warning("Your amount is low for Paypal payment");
        // this.router.navigate(["/dashboard"]);
        // this.loading = false;
        // this.alertService.error("ORDER_ALREADY_CAPTURED");
        //this.router.navigate(["/dashboard"]);
      } else {
        this.alertService.warning("Something went wrong");
      }
    });
  };

  payoutOrder = async () => {
    const response2 = await fetch(
      `${environment.sandBoxUrll}v1/payments/payouts`,
      {
        method: "POST",
        headers: {
          Authorization:
            "Bearer " + localStorage.getItem("CreatePaypalTokenresp"),
          "Content-Type": "application/json",
        },
        body: `{
            "items": [
                {
                    "amount": {
                        "currency": "USD",
                        "value": ${this.payPayOutValue}
                    },
                    "note": "Thanks for your patronage!",
                    "receiver": "${this.paypalPayer_id}",
                    "recipient_type": "PAYPAL_ID",
                    "sender_item_id": "${this.payerToken_id}"
                }
            ],
            "sender_batch_header": {
                "email_message": "You have a payout!",
                "email_subject": "You have received a payout! Thanks for using our service!",
                "sender_batch_id": "${this.unique}"
            }
        }`,
      }
    ).then(async (response) => {
      if (response.status == 201) {
        // this.loading = true;
        const responseData = await Promise.all([response.json()]);
        this.payoutStatus = response.status;
        this.getPayoutApi = responseData[0].links[0].href;
        this.getPaymentPayouts();
        //this.alertService.success("Payment Successfully done.");
        //this.router.navigate(["/dashboard"]);
        // setTimeout(() => {
        //this.loading = true;

        // }, 500);
        //this.loading = false;
        return responseData;
      } else if (response.status == 422) {
        //this.sellerMakePayment();
        // this.alertService.success("Payment Successfully done.");
        this.loading = false;
        this.alertService.warning("Your account balance is low");
        //this.router.navigate(["/dashboard"]);
        //this.loading = false;
        //this.alertService.warning("Your account balance is low");
        // this.alertService.error("Your account balance is low");
      } else {
        //this.loading = false;
        // this.alertService.warning("Your account balance is low");
      }
    });
  };

  getPaymentPayouts = async () => {
    await fetch(`${this.getPayoutApi}`, {
      method: "GET",
      headers: {
        Authorization:
          "Bearer " + localStorage.getItem("CreatePaypalTokenresp"),
        "Content-Type": "application/json",
      },
    }).then(async (response) => {
      if (response.status == 200) {
        //this.loading = false;
        setTimeout(() => {
          this.updatePayment();
          this.router.navigate(["/dashboard"]);
        }, 5000);
        this.alertService.success("Payment Successfully done.");

        //this.alertService.success("Payment Successfully done.");
        const responseData = await Promise.all([response.json()]);
        return responseData;
      } else {
        // this.alertService.error("Something went wrong");
      }
    });
  };

  /**
   *
   */
  public getItemDetail() {
    this.item_id = this._id;
    this.galleryImages = [];
    this.galleryImagesUser = [];
    this.advtService.getTradeItemDetail(this.item_id).subscribe(
      (data) => {
        this.ItemData = data;
        this.ItemID = data.item_id;
        this.showButton = data.showButton;
        // this.timeset = (data.meta.videos + '#t=0,10');
        if (data) {
          if (data.trade_item_meta) {
            if (typeof data.trade_item_meta.images !== undefined) {
              if (data.trade_item_meta.images) {
                this.galleryImages = [];
                for (
                  let i = 0;
                  i < Object.keys(data.trade_item_meta.images).length;
                  i++
                ) {
                  if (typeof data.trade_item_meta.images[i] !== undefined) {
                    const csvArray = data.trade_item_meta.images[i];
                    this.galleryImages.push({
                      small: csvArray,
                      medium: csvArray,
                      big: csvArray,
                    });
                  }
                }
              }
            }
          }
        } else {
          if (data.trade_item_meta.images) {
            this.galleryImages = [];
            for (
              let i = 0;
              i < Object.keys(data.trade_item_meta.images).length;
              i++
            ) {
              if (typeof data.trade_item_meta.images[i] !== "undefined") {
                const csvArray = data.trade_item_meta.images[i];
                this.galleryImages.push({
                  small: csvArray,
                  medium: csvArray,
                  big: csvArray,
                });
              }
            }
          }
        }
        if (data) {
          if (data.item_meta) {
            if (typeof data.item_meta.images !== undefined) {
              if (data.item_meta.images) {
                this.galleryImagesUser = [];
                for (
                  let i = 0;
                  i < Object.keys(data.item_meta.images).length;
                  i++
                ) {
                  if (typeof data.item_meta.images[i] !== undefined) {
                    const csvArray = data.item_meta.images[i];
                    this.galleryImagesUser.push({
                      small: csvArray,
                      medium: csvArray,
                      big: csvArray,
                    });
                  }
                }
              }
            }
          }
        } else {
          if (data.item_meta.images) {
            this.galleryImagesUser = [];
            for (
              let i = 0;
              i < Object.keys(data.item_meta.images).length;
              i++
            ) {
              if (typeof data.item_meta.images[i] !== "undefined") {
                const csvArray = data.item_meta.images[i];
                this.galleryImagesUser.push({
                  small: csvArray,
                  medium: csvArray,
                  big: csvArray,
                });
              }
            }
          }
        }

        this.listSingleItem = data;
        // if(this.buyer_id == this.listSingleItem.buyer_id && this.listSingleItem.status_id == 3){
        if (this.listSingleItem.trade_item_meta) {
          if (this.listSingleItem.trade_item_meta.videos) {
            this.itemVideoName =
              this.listSingleItem.trade_item_meta.videos.split("/")[5];
          }
        }

        // if(this.listSingleItem.meta.music !== undefined){
        //     this.itemAudioName = this.listSingleItem.meta.music[0].split("/")[5];
        // }
        // }

        this.bid_Amount = data.min_bid;
      },
      (error) => {
        this.alertService.error(error);
      }
    );
  }

  public saveFile(videourl, itemVideoName) {
    var ext = videourl.substr(videourl.lastIndexOf(".") + 1);
    FileSaver.saveAs(videourl, itemVideoName);
  }

  public saveAudio(audiourl, itemAudioName) {
    FileSaver.saveAs(audiourl, itemAudioName);
  }

  public saveImageFile(imageurl, itemImageName) {
    const newImageUrl = imageurl.replace(/^https:\/\//i, "http://");
    this.http
      .get(newImageUrl, {
        responseType: ResponseContentType.Blob,
      })
      .toPromise()
      .then((res: any) => {
        let blob = new Blob([res._body], {
          type: res.headers.get("Content-Type"),
        });
        saveAs(blob, newImageUrl.split("/")[5]);
      });
    // let url =imageurl+'?56556';
    let url = imageurl;
    if (imageurl) {
      this.itemImageName = imageurl.split("/")[5];
    }
    //let url = url.replace(/^https:\/\//i, 'http://');
    // FileSaver.saveAs(url,imageurl.split("/")[5]);
  }

  public saveAllImageFiles(imageurls) {
    let array = imageurls;
    for (let i = 0; i < array.length; i++) {
      const newImageUrl = array[i].replace(/^https:\/\//i, "http://");
      this.http
        .get(newImageUrl, {
          responseType: ResponseContentType.Blob,
        })
        .toPromise()
        .then((res: any) => {
          let blob = new Blob([res._body], {
            type: res.headers.get("Content-Type"),
          });
          saveAs(blob, newImageUrl.split("/")[5]);
        });
    }
  }

  backClicked() {
    this._location.back();
  }

  getAllRatingList(ratingtemplate: TemplateRef<any>) {
    this.modalText = "Rating";
    // this.pageNo = (this.pageSize) - this.pageSize;
    const params = {
      seller_id: this.listSingleItem.seller_id,
      limit: 10000,
      offset: 0,
    };
    this.advtService.getRatingList(params).subscribe((data) => {
      if (data.status === 200) {
        this.UsersRating = data.result;
        this.UserRatingCount = data.result.count;
      }
    });
    this.modalRef = this.modalService.show(
      ratingtemplate,
      Object.assign({}, { class: "gray modal-md" })
    );
  }

  acceptRejectTrade(mode, id) {
    let tempStatus;
    if (mode == "accept") {
      tempStatus = 2; // accept trade
    } else {
      tempStatus = 3; // decline trade
    }
    let param = {
      request_id: id,
      status: tempStatus,
    };
    this.advtService.acceptRejectTrade(param).subscribe(
      (data) => {
        if (data.status === 200) {
          if (mode == "accept") {
            this.alertService.success("Trade Accepted Successfully!");
            this.ngOnInit();
            // let ratingCheck = JSON.parse(localStorage.getItem('currentUser'));
            // ratingCheck.result.rating_pending = 1;
            // ratingCheck.result.rating_against_seller = tempID;
            // localStorage.setItem("currentUser", JSON.stringify(ratingCheck));
          } else {
            this.alertService.success("Trade Rejected Successfully!");
            this.ngOnInit();
          }
        }
      },
      (error) => {
        this.alertService.error(error);
      }
    );
  }

  openPayment() {
    this.openModal(this.paymentModal);
    this.createSandBoxOrderHref();
  }

  /**
   *
   * @param token token generated during the transaction
   */
  createOrder(token) {
    let tempID;
    if (this.ItemData.receiver_id == this.buyer_id) {
      tempID = this.ItemData.trade_item_id;
    } else if (this.ItemData.sender_id == this.buyer_id) {
      tempID = this.ItemData.item_id;
    }
    this.loading = true;
    const params = {
      buyer_id: this.buyer_id,
      amount: this.amountCent,
      item_id: tempID,
      payment_token: token,
    };
    this.advtService.getPaymentToken(token, params).subscribe((res) => {
      if (res.status === 200) {
        this.updatePayment();
        this.status = true;
        // this.alertService.success("Payment Successfully done.");
        // this.ngOnInit();
        // this.router.navigate(['/dashboard']);
        this.loading = false;
      } else {
        this.status = false;
      }
    });
  }

  // openRating(){
  //  let  config = { backdrop: true, ignoreBackdropClick: false , keyboard: false };
  //   this.modalRef = this.modalService.show(RatingDialogComponent, config);
  // }

  updatePayment() {
    let paymentSender, paymentReciever;
    if (this.ItemData.receiver_id == this.buyer_id) {
      paymentSender = this.ItemData.receiver_id;
      paymentReciever = this.ItemData.sender_id;
    } else if (this.ItemData.sender_id == this.buyer_id) {
      paymentSender = this.ItemData.sender_id;
      paymentReciever = this.ItemData.receiver_id;
    }
    let param = {
      trade_id: this._id,
      amount: this.amountCent,
      payment_sender: paymentSender,
      payment_receiver: paymentReciever,
    };
    this.advtService.updatePayment(param).subscribe(
      (data) => {
        if (data) {
          //this.ngOnInit();
          // this.ngOnInit();
        }
      },
      (error) => {
        this.alertService.error(error);
      }
    );
  }

  _checkNumPattern(event: any) {
    const pattern = /[0-9\+\.\ ]/;
    if (event.which === 32 && event.target.selectionStart === 0) {
      return false;
    }
    if (event.which === 48 && event.target.selectionStart === 0) {
      return false;
    }
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  _disposeModal() {
    this.modalRef.hide();
  }

  openRating() {
    this.emojiCheck();
    this.openModal(this.ratingdialog);
  }

  public rateSeller(currentUser) {
    let tempID;
    if (this.ItemData.receiver_id == this.buyer_id) {
      tempID = this.ItemData.sender_id;
    } else if (this.ItemData.sender_id == this.buyer_id) {
      tempID = this.ItemData.receiver_id;
    }
    // this.advtService.getUserInfoId(this.currentUser.id).subscribe(res => {
    // });

    // const userInfo = JSON.parse(localStorage.getItem('currentUser'));
    // this.currentUser = userInfo ? userInfo.result : null;

    if (this.currentUser) {
      this.loading = true;
      const params = {
        buyer_id: this.currentUser.id,
        item_id: this.ItemID,
        seller_id: tempID,
        rating: this.rating ? this.rating : 5,
        comment: this.comment,
      };
      this.advtService.rateSeller(params).subscribe((res) => {
        if (res.status == 200) {
          this._NotificationsService.success(res.message);
          this.comment = "";
          let ratingCheck = JSON.parse(localStorage.getItem("currentUser"));
          ratingCheck.result.rating_pending = 0;
          ratingCheck.result.rating_against_seller = 0;
          localStorage.setItem("currentUser", JSON.stringify(ratingCheck));
          // this.router.navigate(['/dashboard']);
        } else {
          this._NotificationsService.warn(res.message);
        }
      });
    }

    this._disposeModal();
    this.loading = false;
  }

  public emojiCheck() {
    if (this.rating === 1) {
      this.emojiIcon = "../assets/images/one.png";
    } else if (this.rating === 2) {
      this.emojiIcon = "../assets/images/two.png";
    } else if (this.rating === 3) {
      this.emojiIcon = "../assets/images/three.png";
    } else if (this.rating === 4) {
      this.emojiIcon = "../assets/images/four.png";
    } else if (this.rating === 5) {
      this.emojiIcon = "../assets/images/five.png";
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/authorized-data/trade/trade-detail/trade-detail.component.ts